import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  ClickAwayListener,
  Checkbox,
  Chip,
  Icon,
  List,
  ListItem,
  ListSubheader,
  Popper,
  Slider,
} from '@material-ui/core';
import { Fragment } from 'react';
import { isEqual } from 'lodash'


class SliderFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prevValue: null,
      value: props.selected || props.defaultValue,
      label: props.label || 'Interest',
      open: false,
      disabled: this.props.disabled || false,
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.selected) !== JSON.stringify(this.props.selected)) {
      this.setState({
        value: this.props.selected || this.props.defaultValue,
      })
    }
  }

  handleOpen = () => {
    this.setState(state => ({ open: !state.open, prevValue: state.value }));
  }

  handleDelete = () => {
    this.setState(state => ({ value: this.props.defaultValue, prevValue: state.value }), this.handleChange);
  }

  handleChange = () => {
    if (this.state.prevValue !== this.state.value && !this.props.readonly && (!this.props.updateAfterClose || (this.props.updateAfterClose === true && this.state.open === false))) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: {
            [this.props.name]: this.state.value,
          }
        }
      })
    }
  }

  handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ open: false }, this.handleChange)
  }

  renderButtonLabel() {
    return this.state.label
  }

  render() {
    const { classes, description, defaultValue, min, max, step, marks, prependLabel, appendLabel } = this.props;
    const { open, value, disabled } = this.state;

    return(
      <div role="tab" className={classes.root}>
        <Chip
          disabled={disabled}
          aria-owns={open ? 'interests-list-grow' : null}
          aria-haspopup="true"
          buttonRef={node => { this.anchorEl = node; }}
          classes={{root: classes.chipRoot, avatar: classes.chipAvatar, icon: classes.chipIcon, colorPrimary: classes.chipSelected}}
          label={this.renderButtonLabel()}
          clickable={true}
          color={(open || !isEqual(value, defaultValue)) ? "primary" : "default"}
          onClick={this.handleOpen}
          onDelete={isEqual(value, defaultValue) ? this.handleOpen : this.handleDelete}
          deleteIcon={isEqual(value, defaultValue) ?
            <Icon className={`${classes.icon} material-icons-outlined notranslate`}>keyboard_arrow_down</Icon>
            :
            <Icon className={`${classes.icon} material-icons-filled notranslate`}>cancel</Icon>
          }
          // icon={<Icon className={[classes.icon, "material-icons-outlined notranslate"]}>hiking</Icon>}
        />
        <Popper open={this.state.open}
          anchorEl={this.anchorEl}
          className={classes.popper}
          placement="bottom-start"
          disablePortal={false}
          modifiers={{
            flip: {
              enabled: false,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'window',
            },
            arrow: {
              enabled: false,
              element: this.anchorEl,
            },
          }}>
          <ClickAwayListener onClickAway={this.handleClose}>
            <List className={classes.list} subheader={<ListSubheader disableSticky>
                {description}
                <strong>{(prependLabel || '') + (!Array.isArray(value) ? value : (value[0] === value[1] ? `${value[0]}` : `${value[0]} to ${value[1]}`)) + (!Array.isArray(value) ? (value === max ? '+' : '') : (value[1] === max ? '+' : '')) + (appendLabel || '')}</strong>
              </ListSubheader>}>
              <Slider
                disabled={disabled}
                track={"normal"}
                defaultValue={defaultValue}
                min={marks ? marks[0].value : min}
                max={marks ? marks[marks.length - 1].value : max}
                step={marks ? null : (step || 1)}
                valueLabelDisplay="auto"
                value={value}
                onChange={(event, newValue) => { this.setState({value: newValue}) }}
                marks={marks}
                size="medium"
                classes={{ mark: classes.sliderMark, markLabel: classes.sliderLabel, valueLabel: classes.sliderValueLabel, thumb: classes.sliderThumb, rail: classes.sliderRail, track: classes.sliderTrack }}
              />
            </List>
          </ClickAwayListener>
        </Popper>
      </div>
    )
  }
}

const styles = theme => ({
  popper: {
    top: '4px !important',
    // left: '1px !important',
    // textAlign: 'left',
    zIndex: 100,
  },
  root: {
    fontSize: 12,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'inline-flex',
    position: 'relative',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    lineHeight: '1.4em',
    marginRight: 10,
    marginTop: 0,
    textAlign: 'left',
  },
  icon: {
    fontSize: 21,
    fontWeight: 400,
    marginTop: 0,
    marginRight: -10,
    marginLeft: -7,
    padding: '10px !important',
    verticalAlign: 'middle',
    color: '#828282',
  },
  list: {
    maxWidth: 360,
    minWidth: 220,
    // boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    // borderRadius: 3,
    backgroundColor: '#fff',
    padding: '10px 10px 25px 10px',
    marginRight: 10,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    border: '1px solid #f5f5f5',
    borderRadius: 25,
    fontWeight: 600,
    padding: '10px 40px 20px 40px',
  },
  chipSelected: {
    backgroundColor: '#07c3991a !important',
    boxShadow: 'none !important',
    border: '1px solid #02c39a !important',
  },
  chipRoot: {
    padding: '20px 10px 20px 10px',
    borderRadius: 50,
    marginRight: 0,
    marginBottom: 10,
    // boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    fontWeight: 500,
    fontSize: 14,
    border: '1px solid #ddd',
    backgroundColor: '#fff',

    '&:hover': {
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  chipAvatar: {
    width: '44px !important',
    height: '44px !important',
    marginRight: '4px !important',
  },
  sliderLabel: {
    top: -5,
    fontSize: 12,
    fontWeight: 600,
    color: '#fff',
  },
  sliderMark: {
    backgroundColor: '#bfbfbf',
    height: 14,
    width: 1,
    marginTop: -3,
  },
  sliderRail: {
    height: 8,
    borderRadius: 4,
    width: '100%',
  },
  sliderRoot: {
    color: '#02c39a',
    height: 8,
  },
  sliderTrack: {
    height: 8,
    borderRadius: 4,
  },
  sliderThumb: {
    height: '24px !important',
    width: '24px !important',
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: '-8px !important',
    marginLeft: '-12px !important',
    '&:focus, &:hover': {
      boxShadow: 'inherit',
    },
  },
  sliderValueLabel: {
    lineHeight: 1.2,
    fontSize: 12,
    padding: 0,
    borderRadius: '50% 50% 50% 0',
    left: 'auto',

    '& > span > span': {
      color: '#fff',
      fontWeight: 560,
    }
  },
});

export default withStyles(styles)(SliderFilter);